/* eslint @typescript-eslint/no-explicit-any: 0 */
import React from "react";
import { usePage } from "@danishagro/shared/src/contexts/page.context";
import { useParams } from "react-router-dom";

interface SSH_FeatureHandlerProps {
    featureName: string;
    featureVersions: { [key: string]: () => JSX.Element };
    version?: string;
    alias?: string;
    [key: string]: any;
}

export const SSH_FeatureHandler = React.forwardRef(
    (
        { featureName, featureVersions, version, alias, ...props }: SSH_FeatureHandlerProps,
        ref: any
    ) => {
        const params = useParams();
        const { getFeatureState } = usePage();

        const featureState = getFeatureState(featureName);
        const versionKeys = Object.keys(featureVersions);
        const latestVersion = featureVersions[versionKeys[versionKeys.length - 1]];
        const Component = featureVersions[version || featureState.version] || latestVersion;

        return featureState.activated ? (
            // @ts-ignore
            <Component version={version} {...props} alias={alias} params={params} ref={ref} />
        ) : null;
    }
);

SSH_FeatureHandler.displayName = "SSH_FeatureHandler";
